export default "__VITE_ASSET__EHJO6B5c__"